export const getAgeByRegion = (region?: string) => {
  switch (region) {
    case 'KG':
      return 18;
    case 'KZ':
      return 21;
    case 'TJ':
      return 18;
    default:
      return null;
  }
};
